export default "__VITE_ASSET__BEGcC3Qr__"